export default __webpack_public_path__ + "static/media/Max.1e80ad59.png";